import React from 'react';
import { useTranslate } from '@im/react-localization';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { SearchBar } from 'src/components/AutoSearch/AutoSearch';
import Skeleton from '@mui/material/Skeleton';

type SearchBarType = {
  disabled?: boolean;
  dropdownOptions?: any[];
  formatValue?: (value?: any) => void;
  isLoading?: boolean;
  isLoadingSelected?: boolean;
  onDropdownOptionChange?: (value?: any) => void;
  onRemoveSelected: (value?: any) => void;
  onSearch: (value?: any) => void;
  onValueSelected: (value?: any) => void;
  options: any[];
  placeholder?: string;
  renderValue?: (value: any) => string;
  selectedValue: any;
  value: any;
};
export default function CustomSearchBar({
  disabled = false,
  dropdownOptions,
  formatValue = (data: any) => data,
  isLoading = false,
  isLoadingSelected = false,
  onDropdownOptionChange,
  onRemoveSelected,
  onSearch,
  onValueSelected,
  options = [],
  placeholder = '',
  renderValue = (data: string) => data,
  selectedValue,
  value,
}: Readonly<SearchBarType>) {
  const translate = useTranslate();
  const searchBarProps = {
    autoCompleteProps: {
      disabled,
      filterOptions: (opts: any) => opts,
      freeSolo: false,
      getOptionLabel: formatValue,
      loading: isLoading,
      loadingText: translate('Common.Loading'),
      noOptionsText: translate('Common.NoRecord'),
      onChange: (_: any, value: any, reason: string) => {
        if (reason === 'selectOption') {
          onValueSelected(value);
        }
      },
      options: options || [],
      renderOption: (props: any, c: any) => {
        return (
          <div {...props} key={c.id}>
            <Stack direction={'column'} width={'100%'}>
              <Box
                sx={{
                  fontSize: '14px',
                }}
              >
                {formatValue(c)}
              </Box>
            </Stack>
          </div>
        );
      },
    },
    isDisabled: disabled,
    onSearch,
    placeholder,
    value,
    ...(dropdownOptions && { dropdownOptions }),
    ...(onDropdownOptionChange && { onDropdownOptionChange }),
  };
  return (
    <FormControl>
      <SearchBar {...searchBarProps} />
      {selectedValue && (
        <>
          {isLoadingSelected ? (
            <Stack my={2}>
              <Skeleton height={34} variant="rectangular" />
            </Stack>
          ) : (
            <Stack
              alignItems="center"
              direction="row"
              justifyContent="space-between"
              my={2}
              px={2}
              sx={{
                backgroundColor: '#F3FAFF',
              }}
            >
              <Typography
                sx={{
                  color: '#0164B0',
                  fontSize: '12px',
                }}
              >
                {renderValue(selectedValue)}
              </Typography>
              <IconButton
                onClick={onRemoveSelected}
                size="small"
                sx={{ alignSelf: 'baseline', color: '#0164B0' }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>
          )}
        </>
      )}
    </FormControl>
  );
}
